var SiteView = require('views/site/site-view');
var CourseSettingsService = require('services/course-settings-service');

var Controller = Chaplin.Controller.extend({
  // Place your application-specific controller features here.
  beforeAction: function (params, route, options) {
    var model = CourseSettingsService.getModel();
    model.set('showDev', EF.options.local || options.query.showDev);
    model.set('controller', route.controller);
    var view = this.reuse('site', SiteView, { model: model, container: CourseSettingsService.get('container') || 'body' } );
    (view.refresh || Function).call(view);
  }
});

module.exports = Controller;
